import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { getParamValue } from "../../../utils";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import MembershipProgressBar from "./MembershipProgressBar";
import { responseNotification } from "../../../utils/notify";

export const MembershipProgress: React.FC = () => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [sortOrder, setSortOrder] = useState<any>("ASC");
  const [sortBy, setSortBy] = useState<any>('pointAmount');
  const [isActive, setIsActive] = useState<any>(true);
  const [limit, setLimit] = useState(20);
  const [personalDetailsCheck, setPersonalDetailsCheck] = useState<any>();
  const [merchantDetailsInfo, setMerchantDetailsInfo] = useState<any>();
  const [memberShipLavelId, setMemberShipLavelId] = useState<any>();
  const [merchantLavelDetails, setMerchantLavelDetails] = useState<any>();
  const [memberShipData, setMemberShipData] = useState<any>({
    loading: false,
    data: null,
  });
  const [membershipLevels33, setMembershipLevels33] = useState<any>([]);
  const getMemberships = useCallback(async () => {
    setMemberShipData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/membership/level?userType=MERCHANT&page=0` +
        (sortBy	 ? `&sortBy	=${sortBy}` : ``) +
        (sortOrder ? `&sortOrder=${sortOrder}` : ``) +
        (isActive ? `&isActive=${isActive}` : ``) +
        (limit ? `&limit=${limit}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setMemberShipData({ loading: false, data: res.data });
        setMembershipLevels33(
          res.data.membershipLevels.map((membershipLevel:any) => ({
            name: membershipLevel?.name,
            pointAmount: membershipLevel?.pointAmount || 0,
            logo: membershipLevel?.logo,
          }))
        );
      })
      .catch((err) => {
        setMemberShipData({ loading: false, data: [] });
        console.error("Brand: Error", err);
      });
  }, [sortBy,sortOrder,isActive,limit, page]);

  const fetchMerchantDetails = useCallback(() => {
    try {
      setPersonalDetailsCheck({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/details`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setPersonalDetailsCheck({
              loading: false,
              data: data?.data?.merchant?.merchantPersonalDetail,
            });
            setMerchantDetailsInfo(data?.data?.merchant);
            setMemberShipLavelId(data?.data?.merchant?.membershipLevelId);
          } else {
            setPersonalDetailsCheck({ loading: false, data: null });
            responseNotification(data.statusText || "something went wrong", "error");
          }
        })
        .catch(() => {
          setPersonalDetailsCheck({ loading: false, data: null });
        });
    } catch {
      setPersonalDetailsCheck({ loading: false, data: null });
    }
  }, [token]);

  const fetchMemberShipLavelDetails = useCallback(() => {
    try {
      setMerchantLavelDetails({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/admin/membership/level/details?id=${memberShipLavelId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setMerchantLavelDetails(data?.data?.membershipLevel);
          } else {
            setMerchantLavelDetails({ loading: false, data: null });
            responseNotification(data.statusText || "something went wrong", "error");
          }
        })
        .catch(() => {
          setMerchantLavelDetails({ loading: false, data: null });
        });
    } catch {
      setMerchantLavelDetails({ loading: false, data: null });
    }
  }, [memberShipLavelId]);



  useEffect(() => {
    fetchMerchantDetails();
    fetchMemberShipLavelDetails();
  }, [fetchMerchantDetails,fetchMemberShipLavelDetails]);
  
  useEffect(() => {
    getMemberships();
  }, [getMemberships]);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Uni+Neue:wght@400;500&display=swap"
        rel="stylesheet"
      />
      <section className="p-5 mx-auto my-0 w-full ">
      <MembershipProgressBar
  levels={membershipLevels33}
  currentPoints={merchantLavelDetails?.pointAmount}
/>

      </section>
    </>
  );
};

export default MembershipProgress;
